import React, { useEffect, useState } from 'react';
import { Modal, Spin, Alert, Typography } from 'antd';
import { filmApi } from '../../services/api/film';
import { apiErrorText } from './apiErrorText';
import { refCaption, chipNote, refKindLabel, viewOf } from './enginePromptUtils';
import type { EnginePromptPayload } from '../../types/film';

const { Text } = Typography;

/** 261002 batch 2 (A2) — "Xem bản gửi engine": CHỈ ĐỌC — chữ prompt thật sự gửi Seedance + ảnh/audio tham chiếu (@ImageN, nhãn, thumbnail). */
const EnginePromptModal: React.FC<{ eventId: string | null; onClose: () => void }> = ({ eventId, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [data, setData] = useState<EnginePromptPayload | null>(null);
  useEffect(() => {
    if (!eventId) return;
    let alive = true;
    setLoading(true); setErr(null); setData(null);
    filmApi.enginePrompt(eventId)
      .then((d) => { if (alive) setData(d); })
      .catch((e: any) => { if (alive) setErr(apiErrorText(e, 'Xem bản gửi engine')); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [eventId]);
  const { headline, images, audios, dropped } = viewOf(data || { refs: [] });
  return (
    <Modal open={!!eventId} onCancel={onClose} footer={null} width={900} title="Bản gửi engine (chỉ đọc)" destroyOnClose>
      {loading && <div style={{ padding: 40, textAlign: 'center' }}><Spin /></div>}
      {err && <Alert type="error" message={err} />}
      {data && (
        <div>
          {headline && <div data-testid="ep-headline" style={{ marginBottom: 8, fontWeight: 600 }}>{headline}</div>}
          <Alert type="info" showIcon style={{ marginBottom: 10 }} message={chipNote(data.chipAuthoritative)} />
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
            {images.map((r) => (
              <div key={r.slot} style={{ width: 96, fontSize: 11 }}>
                {r.url ? <img src={r.url} alt={r.label} style={{ width: 96, height: 96, objectFit: 'cover', borderRadius: 6, border: '1px solid #ddd' }} />
                  : <div style={{ width: 96, height: 96, borderRadius: 6, border: '1px dashed #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999' }}>không ảnh</div>}
                <div title={r.roleLine ? `${refCaption(r)}\n${r.roleLine}` : refCaption(r)}><Text strong>{r.slot}</Text> {r.label}</div>
                {r.roleLine && <div style={{ color: '#0958d9', marginTop: 2 }} data-testid={`ep-kind-${r.slot}`}>{refKindLabel(r.kind)}</div>}
              </div>
            ))}
            {audios.map((r) => <div key={r.slot} style={{ fontSize: 11 }}><Text strong>{r.slot}</Text> {r.label}</div>)}
          </div>
          {images.some((r) => r.roleLine) && (
            <div data-testid="ep-roles" style={{ marginBottom: 10, fontSize: 12 }}>
              <div style={{ fontWeight: 600, marginBottom: 2 }}>Câu khai vai (code dựng, nằm đầu prompt)</div>
              {images.filter((r) => r.roleLine).map((r) => <div key={r.slot} style={{ color: '#555', marginBottom: 2 }}>{r.roleLine}</div>)}
            </div>
          )}
          {dropped.length > 0 && (
            <Alert type="warning" showIcon style={{ marginBottom: 10 }} data-testid="ep-dropped" message="Ảnh không được đính"
              description={<ul style={{ margin: 0, paddingLeft: 18, fontSize: 12 }}>{dropped.map((l) => <li key={l}>{l}</li>)}</ul>} />
          )}
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: 12, background: '#fafafa', padding: 10, borderRadius: 6, maxHeight: 460, overflow: 'auto' }}>{data.finalPrompt}</pre>
        </div>
      )}
    </Modal>
  );
};
export default EnginePromptModal;
